var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({ staticClass: "media" }, _vm.$listeners),
    [
      _c(
        "placeholder",
        [
          _c(
            "svg",
            {
              attrs: {
                slot: "placeholder",
                viewBox: "0 0 300 300",
                width: "100%",
                height: "100%"
              },
              slot: "placeholder"
            },
            [
              _c("rect", {
                attrs: { x: "0", y: "0", width: "100%", height: "100%" }
              })
            ]
          ),
          _c(
            "template",
            { slot: "main" },
            [
              _vm._t(_vm.media.media_type, [
                _vm.media.media_type === "image"
                  ? _c("img", {
                      attrs: { src: _vm.media.src, alt: _vm.media.alt }
                    })
                  : _vm.media.media_type === "video"
                  ? _c(
                      "video",
                      { attrs: { controls: "" } },
                      _vm._l(_vm.media.sources, function(source) {
                        return _c("source", {
                          attrs: { src: source.url, type: source.mime_type }
                        })
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }